<template>
  <div class="page-content">
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-10 col-sm-10">
                <h4>Resellers</h4>
              </div>
              <div class="col-2 col-sm-2">
                <button v-if="checkPermission.create" class="btn btn-primary btn-block" @click="addShow">Add Reseller</button>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-hover" v-loading="loading.table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Payment Method</th>
                    <th>Email</th>
                    <th>Address</th>
                    <th>Created Date</th>
                    <th>#</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in rows" :key="i">
                    <td>{{ item.name }}</td>
                    <td>{{ item.payment_method?.name }}</td>
                    <td>{{ item.email }}</td>
                    <td>{{ item.address }}</td>
                    <td>{{ item.created_at_str }}</td>
                    <td>
                      <el-button type="primary" @click="edit(item)" size="mini">Edit</el-button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <el-empty v-if="!rows.length" description="No reseller"></el-empty>
            </div>
            <!-- <b-pagination v-if="total_row > search.per_page" v-model="currentPage" :total-rows="total_row" :per-page="search.per_page"/> -->
          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="show_modal.update" title="Add Reseller" hide-footer @hide="onHide">
      <b-form>
        <b-form-group label="Name">
          <b-form-input v-model="form.name" placeholder="Input business name"></b-form-input>
        </b-form-group>
        <b-form-group label="Email">
          <b-form-input v-model="form.email" placeholder="Input business email"></b-form-input>
        </b-form-group>
        <b-form-group label="Address">
          <b-form-textarea rows="5" v-model="form.address" placeholder="Input business address"></b-form-textarea>
        </b-form-group>
        <b-form-group label="Payment Method">
          <el-select v-model="form.payment_method.id" clearable placeholder="Choose payment method" class="w-100">
            <el-option v-for="item in sof" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </b-form-group>
        <div class="d-flex flex-row float-right mt-2">
          <b-button @click="show_modal.update = false" size="small" class="mr-2">Cancel</b-button>
          <b-button :loading="loading.update" @click="saveReseller" class="mr-2 ml-2" size="small" variant="primary">Save</b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>
<script>
import moment from 'moment';
import resellersApi from '../../api/resellers';
import topupApi from '../../api/topup';
import popupErrorMessages from '../../library/popup-error-messages';

export default {
  name: 'Resellers',
  metaInfo: {
    title: 'Resellers',
  },
  data() {
    return {
      moment,
      loading: {
        table: false,
        update: false,
      },
      show_modal: {
        update: false,
      },
      rows: [],
      total_row: 0,
      form: {
        name: '',
        email: '',
        address: '',
        reseller_id: '',
        payment_method: {
          id: '',
          name: '',
        },
      },
      search: {
        page: this.$route.query?.page || 1,
        per_page: this.$route.query?.per_page || 20,
      },
      active_reseller_id: '',
      sof: [],
    };
  },
  computed: {
    currentPage: {
      get() {
        return this.search.page;
      },
      set(val) {
        this.search.page = val;
        this.getList();
      },
    },
    userProfile() {
      return this.$store.state.auth.userProfile || {};
    },
    activeWorkspace() {
      return this.$store.state.workspace.activeWorkspace || {};
    },
    checkPermission() {
      const users = this.$store.state.backOffice.userProfile;
      const path = this.$router.currentRoute.fullPath;
      const permission = users.permissions.find((v) => path.includes(v.path));
      return permission.configuration;
    },
  },
  mounted() {
    this.getList();
    topupApi.paymentMethodList().then(({ data }) => {
      this.sof = data.sof;
    });
  },
  methods: {
    async getList() {
      this.loading.table = true;
      await resellersApi.getList().then(({ data }) => {
        this.total_row = data.count;
        this.rows = [];
        if (data.rows) {
          this.rows = data.rows.map((v) => {
            v.created_at_str = moment(v.created_at).format('DD MMM YYYY, HH:mm');
            return v;
          });
        }
      });
      this.loading.table = false;
    },
    edit(item) {
      this.form = {
        name: item.name,
        email: item.email,
        address: item.address,
        reseller_id: item._id,
        payment_method: {
          id: item.payment_method?.id,
          name: item.payment_method?.name,
        },
      };
      this.show_modal.update = true;
    },
    async saveReseller() {
      this.loading.update = true;
      const payment_method = this.sof.find((v) => v.id === this.form.payment_method.id);
      this.form.payment_method.name = payment_method?.name;
      const response = await resellersApi.save({
        form: this.form,
      });
      this.loading.update = false;
      await popupErrorMessages(response);
      this.show_modal.update = false;
      this.$message({
        message: this.$t('reseller.success'),
        type: 'success',
      });
      this.getList();
    },
    addShow() {
      this.form = {
        name: '',
        email: '',
        address: '',
        reseller_id: '',
        payment_method: {
          id: '',
          name: '',
        },
      };
      this.show_modal.update = true;
    },
    onHide() {
      this.form = {
        name: '',
        email: '',
        address: '',
        reseller_id: '',
        payment_method: {
          id: '',
          name: '',
        },
      };
      this.show_modal.update = false;
    },
  },
};
</script>
